var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('img',{staticClass:"nav_bg",attrs:{"src":_vm.baseUrl + _vm.licenseImg,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }